import profileReducer from './reducers';

export default profileReducer;
